const ReadMoreProduct = class extends HTMLElement {
    constructor() {
        super();
        this.init()
    }

    connectedCallback() {
        this.init();
    }


    init() {
        const readMoreButton = this.querySelector('.read-more-button');
        const readMoreText = this.querySelector('.product__text');

        const lineCount = this.countLines(readMoreText);

        if (window.innerWidth < 1024) {
            if (lineCount <= 2) {
                readMoreButton.classList.add('hide');
            }
        } else {
            if (lineCount <= 4) {
                readMoreButton.classList.add('hide');
            }
        }


        readMoreButton.addEventListener('click', () => {
            readMoreText.classList.add('expanded');
            readMoreButton.classList.add('hide');
        })
    }

    countLines(element) {
        const style = window.getComputedStyle(element);
        const lineHeight = parseFloat(style.lineHeight);

        const computedLineHeight = lineHeight || parseFloat(style.fontSize) * 1.2;

        const lines = Math.round(element.clientHeight / computedLineHeight);

        console.log(lines)
        return lines + 1;
    }
};

customElements.get('read-more-product') || customElements.define('read-more-product', ReadMoreProduct);